import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../../config/constants';
import { buscarCorSLA } from './regraSLA';

const PdfParecerPendente = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  // Resumo por status do SLA da lista impressa (só status com ocorrência aparecem)
  const resumo = { VERDE: 0, AMARELO: 0, VERMELHO: 0 };
  list.forEach(p => {
    const cor = buscarCorSLA({ especialidade: p.ESPECIALIDADE, tempoParecer: p.MINUTOSAGUARDANDO, dataParecer: p.DATAHORA, leito: p.LEITO });
    if (resumo[cor] !== undefined) resumo[cor] += 1;
  });
  const partesResumo = [];
  if (resumo.VERDE) partesResumo.push(`${resumo.VERDE} no prazo`);
  if (resumo.AMARELO) partesResumo.push(`${resumo.AMARELO} a vencer`);
  if (resumo.VERMELHO) partesResumo.push(`${resumo.VERMELHO} vencidos`);
  const resumoSLA = partesResumo.length ? ` (${partesResumo.join(', ')})` : '';

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Mapa Cirurgico',
    content: () => componentRef.current,
    // onAfterPrint: () => alert('Print sucess')
  });

  return (
    <>
      <button className={'buttonIcon ' + theme}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '20px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
							{
								BACKEND_URL.includes('gruposanta') ? (
									<img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
								) : null
							}
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes {resumoSLA} </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Convênio</th>
                  <th>Especialidade</th>
                  <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let color = '';
                  let statusClass = "ready";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.NOMEPACIENTE;
                  let solicitante = data.NOMEPRESTADOR.split(' ')[0] + ' ' + data.NOMEPRESTADOR.split(' ').slice(-1).join(' ');
                  var days = 0;
                  var rdays = 0;
                  var hours = 0;
                  var rhours = 0;
                  var minutes = 0;
                  var rminutes = 0;

                  let key = "tr-" + data.CODIGOATENDIMENTO + data.DATAHORA;
                  statusClass = "waiting";

                  let time = data.MINUTOSAGUARDANDO;
                  if (data.MINUTOSAGUARDANDO > 60) {
                    if (data.MINUTOSAGUARDANDO > 1440) {
                      days = (data.MINUTOSAGUARDANDO / 1440);
                      rdays = Math.floor(days);
                      hours = (days - rdays) * 24;
                      rhours = Math.floor(hours);
                      minutes = (hours - rhours) * 60;
                      rminutes = Math.round(minutes);
                      time = rdays + " d " + rhours + " h " + rminutes + " m";
                    } else {
                      hours = (data.MINUTOSAGUARDANDO / 60);
                      rhours = Math.floor(hours);
                      minutes = (hours - rhours) * 60;
                      rminutes = Math.round(minutes);
                      time = rhours + " h " + rminutes + " m";
                    }
                  } else {
                    time = time + ' mins';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" > <div className="alert-label" /> <b>{data.LEITO}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"  ><b>{name}</b> | ({data.CODIGOATENDIMENTO})  </td>
                      <td style={{ color: color }} align="left">{<b>{data.CONVENIO.slice(0, 14)}</b>}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{data.ESPECIALIDADE} ({solicitante})</td>
                      <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfParecerPendente;